import AccessibleFakeButton from './AccessibleFakeButton';
import injectInk from '../Inks/injectInk';

export default injectInk(AccessibleFakeButton);


//////////////////
// WEBPACK FOOTER
// ../es/Helpers/AccessibleFakeInkedButton.js
// module id = g/zz
// module chunks = 73